<template>
  <div class="flex flex-col">
    <div class="title">
      Infoauto
    </div>
    <SyncGeneric
      title="Stock And Price partial ONLY"
      type="price_and_stock_partial"
      cta="Update parts stock and price partial, this will call Main API - Affect shared db"
    ></SyncGeneric>
    <SyncGeneric
      title="Stock, Price and locations"
      type="price_and_stock"
      cta="Update parts stock, price and locations - This does not call Main API - NO affect shared db - No disable or enable parts"
    ></SyncGeneric>
    <SyncGeneric
      title="Stock and locations"
      type="stock_only"
      cta="Update parts stock and locations - This does not call Main API - NO affect shared db - No disable or enable parts"
    ></SyncGeneric>
    <SyncGeneric
      title="Full part info - create+update parts, update stock and location - This will call Main API - Affect shared db - Disable or enable parts"
      type="part_info"
      cta=" create+update parts, update stock and location - This will call Main API - Affect shared db - Disable or enable parts"
    ></SyncGeneric>
    <SyncGeneric
      title="Sync sellers"
      type="sellers"
      cta="Sync sellers"
    ></SyncGeneric>
    <SyncGeneric
      title="Sync price levels"
      type="price_levels"
      cta="Sync price levels"
    ></SyncGeneric>
    <SyncGeneric
      title="Sync currencies"
      type="currencies"
      cta="Sync currencies"
    ></SyncGeneric>
    <SyncGeneric
      title="Sync terminales"
      type="terminales"
      cta="Sync terminales"
    ></SyncGeneric>
    <SyncGeneric
      title="Sync grupos_precios"
      type="grupos_precios"
      cta="Sync grupos_precios"
    ></SyncGeneric>
    <SyncGeneric
      title="Sync depositos"
      type="depositos"
      cta="Sync depositos"
    ></SyncGeneric>
    <SyncGeneric
      title="Sync Departamentos"
      type="departamentos"
      cta="Sync Departamentos"
    ></SyncGeneric>
    <SyncGeneric
      title="Sync modalidad_venta"
      type="modalidad_venta"
      cta="Sync modalidad_venta"
    ></SyncGeneric>
    <SyncGeneric
      title="Sync barrios"
      type="barrios"
      cta="Sync barrios"
    ></SyncGeneric>
    <SyncGeneric
      title="Sync cantones"
      type="cantones"
      cta="Sync cantones"
    ></SyncGeneric>
    <SyncGeneric
      title="Sync provincias"
      type="provincias"
      cta="Sync provincias"
    ></SyncGeneric>
    <SyncGeneric
      title="Sync distritos"
      type="distritos"
      cta="Sync distritos"
    ></SyncGeneric>
    <SyncGeneric
      title="Sync paises"
      type="paises"
      cta="Sync paises"
    ></SyncGeneric>
    <SyncGeneric
      title="Sync estados"
      type="estados"
      cta="Sync estados"
    ></SyncGeneric>
    <SyncGeneric
      title="Sync ciudades (después de estados)"
      type="ciudades"
      cta="Sync ciudades"
    ></SyncGeneric>
  </div>
</template>
<script>
import SyncGeneric from "@/components/Infoauto/SyncGeneric.vue";

export default {
  components: {
    SyncGeneric
  }
};
</script>
